import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import fa from 'vuetify/es5/locale/fa';


Vue.use(Vuetify);

import {
  VTextField,
  VAutocomplete,
  VBtn,
  VCard,
  VSelect,
  VTextarea
} from 'vuetify/lib'

VTextField.options.props.outlined.default = true
VTextField.options.props.hideDetails.default = true
VTextField.options.props.dense.default = true
VTextField.options.props.backgroundColor.default = 'white'

VBtn.options.props.small.default = true

VCard.options.props.outlined.default = true

VSelect.options.props.outlined.default = true

VTextarea.options.props.rows.default = 1
VTextarea.options.props.autoGrow.default = true



export default new Vuetify({
  rtl: true,
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#FE9BB2',
        secondary: '#FD6B4B',
        lightSecondary: '#F17359',
        accent: '#9100FF',
        error: '#E01E37',
        danger: '#E01E37',
        info: '#c9184a',
        success: '#590d22',
        warning: '#ff9d00',
        back: '#979DAC',
        tableHeader: '#dae3ed',
        snow: '#FFFFFF',
        success_important: '#04844B',
        black_theme: '#080707',
        firstColor: '#e1ecf2',
        secondColor: '#f2dee7',
        thirdColor: '#fddcd5',
        fourthColor: '#ecede5',
      },
      dark: {
        primary: '#FF7A00',
        secondary: '#FF5500',
        lightSecondary: '#FF7F2A',

        accent: '#F27800',
        error: '#F54747',
        danger: '#F54747',
        info: '#29506D',
        success: '#1C7A4B',
        warning: '#E68600',

        back: '#0A0C10',
        tableHeader: '#11151C',
        snow: '#E4EBF5',

        success_important: '#14B15C',
        black_theme: '#050608',

        firstColor: '#0F1117',
        secondColor: '#13161E',
        thirdColor: '#1A1D27',
        fourthColor: '#21252F',
      }
    },
  },
  lang: {
    locales: {
      fa
    },
    current: 'fa',
  },
  icons: {
    iconfont: 'md',
    values: {
      productBrandIcon: {
        component: () => import('@/icons/ProductbrandIcon.vue')
      },
      productFeatureIcon: {
        component: () => import('@/icons/ProductFeaturesIcon.vue')
      },
      productIcon: {
        component: () => import('@/icons/ProductIcon.vue')
      },
      supplierIcon: {
        component: () => import('@/icons/SupplierIcon.vue')
      },
      registerNewFormIcon: {
        component: () => import('@/icons/RegisternewformIcon.vue')
      },
      registerPackageIcon: {
        component: () => import('@/icons/RegisterpackageIcon.vue')
      },
      removeTheFilterIcon: {
        component: () => import('@/icons/RemovethefilterIcon.vue')
      },
      productCategoryIcon: {
        component: () => import('@/icons/ProductcategoryIcon.vue')
      },
      productBenefitIcon: {
        component: () => import('@/icons/ProductbenefitIcon.vue')
      },
      filterIcon: {
        component: () => import('@/icons/FilterIcon.vue')
      },
      takmilmohtavaIcon: {
        component: () => import('@/icons/TakmilmohtavaIcon.vue')
      },
      darentezarmohtava1Icon: {
        component: () => import('@/icons/Darentezarmohtava1Icon.vue')
      },
      darentezarpardakhtIcon: {
        component: () => import('@/icons/DarentezarpardakhtIcon.vue')
      },
      storereceiptIcon: {
        component: () => import('@/icons/StorereceiptIcon.vue')
      },
      businessIcon: {
        component: () => import('@/icons/BusinessIcon.vue')
      },
      personalizationIcon: {
        component: () => import('@/icons/PersonalizationIcon.vue')
      },
      sefareshhaykasbokarIcon: {
        component: () => import('@/icons/SefareshhaykasbokarIcon.vue')
      },
      allProductsIcon: {
        component: () => import('@/icons/AllproductsIcon.vue')
      },
      selectproductIcon: {
        component: () => import('@/icons/SelectproductIcon.vue')
      },
      pdfIcon: {
        component: () => import('@/icons/PdfIcon.vue')
      },
      tarikhcheIcon: {
        component: () => import('@/icons/TarikhcheIcon.vue')
      },
      peygiriIcon: {
        component: () => import('@/icons/PeygiriIcon.vue')
      },
      packagesIcon: {
        component: () => import('@/icons/PackagesIcon.vue')
      },
      printIcon: {
          component: () => import('@/icons/PrintIcon.vue')
      },
      productinputIcon: {
        component: () => import('@/icons/ProductinputIcon.vue')
      },
      tahvilshodeIcon: {
        component: () => import('@/icons/TahvilshodeIcon.vue')
      },
      currencyIcon: {
        component: () => import('@/icons/CurrencyIcon.vue')
      },
      dashboardIcon: {
        component: () => import('@/icons/DashboardIcon.vue')
      },
      settingIcon: {
        component: () => import('@/icons/SettingIcon.vue')
      },
      affiliateIcon: {
        component: () => import('@/icons/AffiliateIcon.vue')
      },
      incomegenerationIcon: {
        component: () => import('@/icons/IncomegenerationIcon.vue')
      },
      profitreportIcon: {
        component: () => import('@/icons/ProfitreportIcon.vue')
      },
      darEntezarTahvilIcon: {
        component: () => import('@/icons/DarentezartahvilIcon.vue')
      },
      safeIcon: {
        component: () => import('@/icons/SafeIcon.vue')
      },
      getInformationIcon: {
        component: () => import('@/icons/GetinformationIcon.vue')
      },
      buySaleIcon: {
        component: () => import('@/icons/BuySaleIcon.vue')
      },
      warehouseIcon: {
        component: () => import('@/icons/WarehouseIcon.vue')
      },
      kifpoolIcon: {
        component: () => import('@/icons/KifpoolIcon.vue')
      },
      gardeshhesabIcon: {
        component: () => import('@/icons/GardeshhesabIcon.vue')
      },
      pardakhthaIcon: {
        component: () => import('@/icons/PardakhthaIcon.vue')
      },
      darentezarersalIcon: {
        component: () => import('@/icons/DarentezarersalIcon.vue')
      },
      ersalshodeIcon: {
        component: () => import('@/icons/ErsalshodeIcon.vue')
      },
      bastebandiIcon: {
        component: () => import('@/icons/BastebandiIcon.vue')
      },
      crmIcon: {
        component: () => import('@/icons/CrmIcon.vue')
      },
      bastebandishomaIcon: {
        component: () => import('@/icons/BastebandishomaIcon.vue')
      },
      chapdastejamiIcon: {
        component: () => import('@/icons/ChapdastejamiIcon.vue')
      },
      sefareshatIcon: {
        component: () => import('@/icons/SefareshatIcon.vue')
      },
      forooshkasbokarIcon: {
        component: () => import('@/icons/ForooshkasbokarIcon.vue')
      },
      darentezarbastebandiIcon: {
        component: () => import('@/icons/DarentezarbastebandiIcon.vue')
      },
      bastebandishodeIcon: {
        component: () => import('@/icons/BastebandishodeIcon.vue')
      },
      postshodeIcon: {
        component: () => import('@/icons/PostshodeIcon.vue')
      },
      transactionIcon: {
        component: () => import('@/icons/TransactionIcon.vue')
      },
      reportIcon: {
        component: () => import('@/icons/ReportIcon.vue')
      },
      transportationIcon: {
        component: () => import('@/icons/TransportationIcon.vue')
      },
      clearFiltersIcon: {
        component: () => import('@/icons/ClearFilters.vue')
      },
      curvedArrowLeftIcon: {
        component: () => import('@/icons/CurvedArrowLeft.vue')
      },
      costAccountingIcon: {
        component: () => import('@/icons/CostAccountingIcon.vue')
      },
      sanadIcon: {
        component: () => import('@/icons/SanadIcon.vue')
      },
      accountsTreeIcon: {
        component: () => import('@/icons/AccountsTreeIcon.vue')
      },
      accountIcon: {
        component: () => import('@/icons/AccountIcon.vue')
      },
      balanceReportIcon: {
        component: () => import('@/icons/BalanceReportIcon.vue')
      },
      ledgerReportIcon: {
        component: () => import('@/icons/LedgerReportIcon.vue')
      },
      factorIcon: {
        component: () => import('@/icons/FactorIcon.vue')
      },
      inputFactorIcon: {
        component: () => import('@/icons/InputFactorIcon.vue')
      },
      outputFactorIcon: {
        component: () => import('@/icons/OutputFactorIcon.vue')
      },
      receiveTransactionIcon: {
        component: () => import('@/icons/ReceiveTransactionIcon.vue')
      },
      paymentTransactionIcon: {
        component: () => import('@/icons/PaymentTransactionIcon.vue')
      },
      shippedIcon: {
        component: () => import('@/icons/Confirm.vue')
      },
    }
  },
});